var map = {
	"./landing-page-en/feature-1_3x.png": [
		68619,
		4659
	],
	"./landing-page-en/feature-2_3x.png": [
		47401,
		9531
	],
	"./landing-page-en/feature-3_3x.png": [
		82319,
		1980
	],
	"./landing-page-pt/feature-1_3x.png": [
		68022,
		4711
	],
	"./landing-page-pt/feature-2_3x.png": [
		23172,
		8607
	],
	"./landing-page-pt/feature-3_3x.png": [
		93168,
		1920
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 19090;
module.exports = webpackAsyncContext;